var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center pa-3 background-secondary heading-title-small"},[_vm._t("default",function(){return [_c('base-typography',{attrs:{"value":_vm.title,"single":""}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }